(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('DialyserTypeDetailController', DialyserTypeDetailController);

    DialyserTypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DialyserType', 'Infection', 'Corporation'];

    function DialyserTypeDetailController($scope, $rootScope, $stateParams, previousState, entity, DialyserType, Infection, Corporation) {
        var vm = this;

        vm.dialyserType = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:dialyserTypeUpdate', function(event, result) {
            vm.dialyserType = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
